import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MainLayout from './MainLayout'; // ✅ import MainLayout

const RunOpenMKMPage = () => {
  const [message, setMessage] = useState('Starting job...');
  const navigate = useNavigate();

  useEffect(() => {
    const runJob = async () => {
      const project_id = localStorage.getItem('project_id');
      if (!project_id) {
        setMessage('No project ID found. Please upload files first.');
        return;
      }
      const token = localStorage.getItem('token');

      try {
        const response = await axios.post(
          'https://openmkm.vidyayug.com/api/run/openmkm',
          { project_id },
          {
            headers: {
              Authorization: `${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        const { job_id } = response.data;

        if (job_id) {
          localStorage.setItem('job_id', job_id);
          setMessage('Job started successfully! Redirecting to job status...');
          setTimeout(() => {
            navigate('/job-status');
          }, 1000);
        } else {
          setMessage('Job started but job_id not received.');
        }
      } catch (error) {
        console.error(error);
        setMessage('Failed to start job.');
      }
    };

    runJob();
  }, [navigate]);

  return (
    <MainLayout>
      <div style={styles.container}>
        <div style={styles.card}>
          <h2>{message}</h2>
        </div>
      </div>
    </MainLayout>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 60px)',
    paddingTop: '40px',
    background: '#f9fafb',
  },
  card: {
    background: '#fff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
};

export default RunOpenMKMPage;
